import { LoanState } from "../loan.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";

export const confirmOfferReducer = (
  state: LoanState,
  action: PayloadAction<string>,
) => {
  const selectedOffer = state.offers?.find(
    (offer) => offer.id === action.payload,
  );
  state.confirmedOffer = {
    ...state.confirmedOffer,
    id: action.payload,
    isSelected: selectedOffer?.isSelected,
    interests: selectedOffer?.interests!,
    isDiscounted: selectedOffer?.isDiscounted,
    tan: selectedOffer?.tan,
    requestedAmount: selectedOffer?.requestedAmount,
    taeg: selectedOffer?.taeg,
    installmentsCount: selectedOffer?.installmentsCount,
    insurance: selectedOffer?.insurance,
    installmentsAmount: selectedOffer?.installmentsAmount,
    totalAmount: selectedOffer?.totalAmount ?? undefined,
  };
};
